import React, { useEffect, useState } from 'react';
import validate from 'src/utils/validate';
import { Popup, Input, Button } from 'zarm';

import './index.scss';
import StaticToast from '../toast';
import { fetchJson } from 'src/utils';
import { shallowEqual, useSelector } from 'react-redux';
import { ApplicationState } from 'src/store';
import { InvoiceTitleType } from 'src/utils/staticData';

interface popupType {
  orderId?: string,
  visible: boolean,
  onClose: any,
  onSuccess: any,
}

interface InvoiceTemplateModel {
  invoiceTitleType: InvoiceTitleType,
  invoiceTitle: string,
  email: string,
  mobile: string,
  taxpayerIdentityNo?: string,
  userName: string,
}

interface InvoiceTemplateDto {
  id?: string;
  userEmail: string,
  userPhone: string,
  invoiceTitleType: InvoiceTitleType,
  userName: string,
  invoiceTitle: string,
  taxpayerIdentityNo?: string,
}

const InvoicePopup = ({orderId, visible, onClose, onSuccess }: popupType) => {
  const { shoppingCart }: any = useSelector((state: ApplicationState) =>
    ({
      shoppingCart: state.prescription.shoppingCart,
    })
  , shallowEqual);

  const [type, setType] = useState<InvoiceTitleType>(InvoiceTitleType.PERSONAL);
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [userName, setUserName] = useState('');
  const [taxpayerIdentityNo, setTaxpayerIdentityNo]= useState('');
  // 当前正在编辑的发票模版 id
  const [editInvoiceTemplateId, setEditInvoiceTemplateId] = useState('');

  const typeOnChange = (value) => {
    console.log('type',type);
    setType(value);
  };
  const mobileonChange = (value) => {
    setMobile(value);
  };

  /**
   * @description 获取发票模板
   */
  const getInvoiceTemplate = () => {
    fetchJson({
      url: '/api/api/v1/patient/invoice/template',
      type: 'GET',
      success: (res: { result: InvoiceTemplateDto[] }) => {
        if(res && res.result && res.result.length > 0){
          const invoiceTemplate = res.result[0];
          const { invoiceTitleType, invoiceTitle, userEmail, userPhone, userName, taxpayerIdentityNo } = invoiceTemplate;
          
          fillInvoiceTemplate({
            invoiceTitleType,
            userName,
            invoiceTitle,
            email: userEmail,
            mobile: userPhone,
            taxpayerIdentityNo,
          });

          setEditInvoiceTemplateId(invoiceTemplate.id || '');
        }
      },
    });
  };

  /**
   * @description 保存发票模板
   */
  const saveInvoiceTemplate = (value: InvoiceTemplateDto) => {
    fetchJson({
      url: '/api/api/v1/patient/invoice/template',
      type: 'POST',
      data: {
        ...value,
        id: editInvoiceTemplateId,
      },
    });
  };
    
  const onConfirm = () => {
    console.log('mobile', mobile, !validate.isMobile(mobile));
    if(type === InvoiceTitleType.COMPANY && title.trim() === ''){
      StaticToast.warning('您输入抬头格式有误');
      return ;
    }
    if(type === InvoiceTitleType.PERSONAL && userName.trim() === ''){
      StaticToast.warning('请输入个人姓名');
      return ;
    }
    if(type === InvoiceTitleType.COMPANY && validate.isEmpty(taxpayerIdentityNo)){
      StaticToast.warning('请输入纳税人识别号');
      return ;
    }
    if(mobile === '' || !validate.isMobile(mobile)){
      StaticToast.warning('您输入手机号格式有误');
      return ;
    }
    if(email === '' || !validate.isEmail(email)){
      StaticToast.warning('您输入邮箱格式有误');
      return ;
    }
    if(!type){
      StaticToast.warning('请选择开票抬头类型');
      return ;
    }

    // 创建基础发票数据对象
    const invoiceData = {
      orderId,
      email,
      mobile,
      invoiceTitleType: type,
      invoiceTitle: type === InvoiceTitleType.COMPANY ? title : userName,
      // 根据发票类型添加额外字段
      taxpayerIdentityNo: type === InvoiceTitleType.COMPANY ? taxpayerIdentityNo : '',
    };

    // 使用可选链操作符调用回调函数
    onSuccess?.(invoiceData);

    saveInvoiceTemplate({
      userEmail: email,
      userPhone: mobile,
      userName,
      invoiceTitleType: type,
      invoiceTitle: title,
      taxpayerIdentityNo,
    });
  };

  /**
   * 回填发票模板
   */
  const fillInvoiceTemplate = (value: InvoiceTemplateModel) => {
    setType(value.invoiceTitleType);
    setMobile(value.mobile);
    setTitle(value.invoiceTitle);
    setUserName(value.userName);
    setEmail(value.email);
    setTaxpayerIdentityNo(value.taxpayerIdentityNo || '');
  };

  useEffect(() => {
    if(shoppingCart.invoiceTitle){
      fillInvoiceTemplate(shoppingCart);
    }
  },[shoppingCart]);

  useEffect(() => {
    if(visible){
      getInvoiceTemplate();
    }
  }, [visible]);

  const titleonChange = (value) => {
    setTitle(value);
  };
  const mailonChange = (value) => {
    setEmail(value);
  };
  const taxpayerIdentityNoonChange = (value) => {
    setTaxpayerIdentityNo(value);
  };
  return (
    <Popup visible={visible} destroy onMaskClick={onClose}>
      <div className='invoice-popup'>
        <div className='title-box'>
          <div className='title'>发票</div>
          <img className='icon-close' onClick={onClose} src={require('./images/icon-close.png')} />
        </div>
        <div className='cont'>发票类型：电子普通发票</div>
        <div className='form-cont'>
          <div className='form-item'>
            <div className='label'>发票抬头</div>
            <div className='radio-group'>
              <div className={type === InvoiceTitleType.PERSONAL ? 'radio-item active' : 'radio-item'} onClick={() => typeOnChange(InvoiceTitleType.PERSONAL)}>个人</div>
              <div className={type === InvoiceTitleType.COMPANY ? 'radio-item active' : 'radio-item'} onClick={() => typeOnChange(InvoiceTitleType.COMPANY)}>单位</div>
            </div>
          </div>
          {
            type === InvoiceTitleType.COMPANY ?(
              <div>
                <div className='form-item'>
                  <div className='label'>单位名称</div>
                  <Input value={title} onChange={titleonChange} placeholder='请填写单位名称' />
                </div>
                <div className='form-item'>
                  <div className='label'>纳税人识别号</div>
                  <Input value={taxpayerIdentityNo} onChange={taxpayerIdentityNoonChange} placeholder='请填写纳税人识别号' />
                </div>
              </div>

            ): (
              <div className='form-item'>
                <div className='label'>个人姓名</div>
                <Input value={userName} onChange={(value) => setUserName(value)} placeholder='请填写个人姓名' />
              </div>
            )
          }
        </div>
        <div className='cont'>收票人信息</div>
        <div className='form-cont'>
          <div className='form-item'>
            <div className='label'>收票人手机</div>
            <Input value={mobile} maxLength={11} onChange={mobileonChange} placeholder='用于接收电子发票短信' />
          </div>
        </div>
        <div className='form-cont'>
          <div className='form-item'>
            <div className='label'>收票人邮箱</div>
            <Input type='email' value={email} onChange={mailonChange} placeholder='用于接收电子发票' />
          </div>
        </div>
        <div className='tips'>提示：发票开具后不支持重开，如有问题请及时联系客服处理</div>
        <div className='button-group'>
          <Button shape='round' block theme='primary' className='btn-confirm' onClick={onConfirm}>确认</Button>
        </div>
      </div>

    </Popup>
  );
};
export default InvoicePopup;
